
// 获取链接参数值
export function getQueryVariable(variable) {
	let query = window.location.search.substring(1);
	let vars = query.split("&");
  if (!variable) {
    const querys = {}
    for (let i = 0; i < vars.length; i++) {
      let mapString = vars[i].split("=");
      querys[mapString[0]] = mapString[1]
    }
    return querys
  }
	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split("=");
		if (pair[0] == variable) return pair[1];
	}
	return null;
}

// 数组对象顺序
export function compare(prop) {
	return (obj1, obj2) => {
		let val1 = obj1[prop];
		let val2 = obj2[prop];
		if (val1 < val2) {
			return -1;
		} else if (val1 > val2) {
			return 1;
		} else {
			return 0;
		}
	}
}

export function getYoutubeId (youtubeLink) {
  var regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|live|watch|shorts)(?:\?v=|\?=\S*\/|\/))|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  var match = youtubeLink.match(regExp);
  return match?.length ? match[1] : false;
}

export function copyText (content) {
  const copyDom = document.createElement("textarea");
    copyDom.value = content;
  document.body.appendChild(copyDom);
  return new Promise((resolve) => {
    setTimeout(() => {
      try {
        copyDom.select();
        document.execCommand("Copy");
        document.body.removeChild(copyDom);
        resolve(true);
      } catch (err) {
        resolve(false);
      }
    }, 100);
  });
};

/*
 * 设置 Cookie的方法
 * @cname: 需要写入的数据的key值
 * @cvalue: 需要写入的数据的值
 */
export function setCookie (cname, cvalue) {
	document.cookie = cname + "=" + cvalue + ";path=/";
};
/*
 * 获取 Cookie的方法
 * @cname: 需要获取的数据的key值
 */
export function getCookie (cname) {
	var name = cname + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i].trim();
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

export const groupby = (list, fn) => {
	const groups = {};

	list.foreach( (o) => {
		const group = fn(o)
		groups[group] = groups[group] || []
		groups[group].push(o)
	})

	return groups;
}

// 将rgb颜色转成hex  输入(24,12,255)
export function colorRGB2Hex(rgb) {
  try {
    const matchList = rgb.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/)
    const r = Number( matchList[1])
    const g = Number( matchList[2])
    const b = Number( matchList[3])
    let hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return hex;
  } catch {
    return hex
  }
}

// 文件流转换
export function dataURLtoBlob (base64Data) {
  let arr = base64Data.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime })
}

// blob转本地链接
export function getBase64URL(base64) {
  const blob = dataURLtoBlob(base64)
  const blobUrl = window.URL.createObjectURL(blob);
  return blobUrl
}

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};


//生成二维码
export async function generateQR(path) {
  const jrQrcode = await import("jr-qrcode")
  return jrQrcode.getQrBase64(path);
}

// 是否有效链接
export function isLink (path) {
  const reg = /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-])((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|](?!([^<]*>)|([^<]*<\/a>))/gi
  return reg.test(path)
}


// 获取剩余时间
export function getTimeRemaining(endtime) {
  const t = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((t / 1000) % 60);
  const minutes = Math.floor((t / 1000 / 60) % 60);
  const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  const days = Math.floor(t / (1000 * 60 * 60 * 24));
  if (days < 0) {
    return false
  }
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

// 获取标签属性
export function getDomAttributeValue ({ tag, key, regString, reg }) {
  const regex = reg || new RegExp(`<${tag}[^>]*\\s${key}="([^"]*)"`, 'gi')
  let matchValue = regex.exec(regString)
  return matchValue?.[1]
}

// 移出链接及尖括号
export function removeLinksAndBrackets(text) {
  // 综合正则：匹配链接 + 标签 + 单独尖括号
  const regex = /<(?:[^>]+)>|(?:https?|ftp):\/\/[\w\-.]+\S*|www\.[\w\-.]+\S*|[<>]/gi;
  return regex.test(text);
}

// 获取图片宽高
export function getImageDimensions(file) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = file.content;
    img.onload = () => {
      file.width = img.naturalWidth;
      file.height = img.naturalHeight;
      resolve();
    };
    img.onerror = () => resolve(); // 错误处理
  });
}

export function getSelectionPosition () {
  const selection = window.getSelection();
    
    // 检查是否有选中文本且未折叠（未取消选择）
    if (selection.rangeCount === 0 || selection.isCollapsed) {
        return null;
    }
    
    const range = selection.getRangeAt(0);
    // 创建仅包含结束点的临时范围
    const endRange = document.createRange();
    endRange.setStart(range.endContainer, range.endOffset);
    endRange.collapse(true);
    
    // 获取结束点的边界矩形（可能返回多个矩形，取最后一个）
    const rects = endRange.getClientRects();
    if (rects.length === 0) return null;
    
    const lastRect = rects[rects.length - 1];
    return {
      pageX: lastRect.right + window.pageXOffset,  // 页面绝对X坐标
      pageY: lastRect.bottom + window.pageYOffset, // 页面绝对Y坐标
      clientX: lastRect.right,                     // 视口X坐标
      clientY: lastRect.bottom,                    // 视口Y坐标
      element: endRange.commonAncestorContainer   // 结束点所在元素
  };
}